export default __webpack_public_path__ + "static/media/FiraSans-SemiBoldItalic.8ca830e8.woff2";